export default "__VITE_ASSET__CN$u5Fdq__"